import React from 'react';
import styled from 'styled-components';
import { HudIcon } from '../../Icons/HudIcons';
import { FilterButton } from '../../Charts/LineChart/LineChart.styles';
import type { DataKey } from '../../Charts/LineChart/LineChart';
import { themeColor } from '../../theme/colors';
import Tooltip from '../../Tooltip/Tooltip';
import { Popover } from '../../Popover/Popover';
import { clickableMixin } from '../../theme/utils';

interface FilterMenuButtonProps {
  dataKeys: DataKey[];
  hiddenKeys: string[];
  onToggle: (key: string) => void;
}

export function FilterMenuButton({
  dataKeys,
  hiddenKeys,
  onToggle,
}: FilterMenuButtonProps) {
  return (
    <Popover
      position="bottom"
      body={
        <OptionList>
          {dataKeys.map((dataKey) => (
            <Option key={dataKey.key} onClick={() => onToggle(dataKey.key)}>
              <CheckedContainer>
                {!hiddenKeys.includes(dataKey.key) && (
                  <HudIcon icon="other.check" size="18px" />
                )}
              </CheckedContainer>{' '}
              {dataKey.label || dataKey.key}
            </Option>
          ))}
        </OptionList>
      }
    >
      <div>
        <Tooltip description="Select fields to show">
          <FilterButton>
            <HudIcon icon="other.filters" size="17px" />
          </FilterButton>
        </Tooltip>
      </div>
    </Popover>
  );
}

const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Option = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  ${clickableMixin}
`;

const CheckedContainer = styled.span`
  width: 17px;
  height: 17px;
  border-radius: 4px;
  border: 1px solid ${themeColor('textPrimary')};
  display: flex;
  justify-content: center;
  align-items: center;
`;
